import { gql } from '@apollo/client';

// Queries

/**
 * @deprecated This query has been replaced by CREATE_PERSONALIZED_CONTRACT_PREVIEW mutation.
 * Use createPersonalizedContractPreview service instead.
 * See: ~/services/create-personalized-contract-preview
 */
export const FETCH_PERSONALIZED_CONTRACT = gql`
  query Flex_FetchPersonalizedContract($contractVersionId: Int!, $utilityAccountId: Int!) {
    contractVersion(id: $contractVersionId) {
      id
      personalizedFile(utilityAccountId: $utilityAccountId)
    }
  }
`;

export const FETCH_PERCH_PERSONALIZED_CONTRACT = gql`
  query Flex_FetchPerchPersonalizedContract($contractVersionId: Int!, $planId: Int!) {
    contractVersion(id: $contractVersionId) {
      id
      perchPersonalizedFile(planId: $planId)
    }
  }
`;
